import React from 'react';

import { Box, Stack, Typography } from '@lyearn/ui';
import RichTextViewer from '@/components/RichTextViewer';

import Level from '../Level';
import VideoWithPreview from '../VideoWithPreview';
import { AboutComponentProps } from './types';

const AboutComponent: React.FC<AboutComponentProps> = React.memo(
  ({ description, level, previewMedia, levelValue, className, title }) => {
    const isDescriptionEmpty = !description && !level && !previewMedia;
    if (isDescriptionEmpty) {
      return null;
    }

    const marginTopLevel = !previewMedia ? 'mt-0 mb-32' : 'my-32';
    const marginTopContent = !previewMedia && !level ? 'mt-0' : 'mt-40';

    return (
      <Stack className={className} direction="col">
        <Typography as="h2" className="mb-24" variant="heading-m">
          {title}
        </Typography>
        {previewMedia ? <VideoWithPreview media={previewMedia} /> : null}
        {!level ? null : <Level className={marginTopLevel} level={level} levelValue={levelValue} />}
        {description ? (
          <Box className={marginTopContent}>
            <RichTextViewer
              as="div"
              className="w-full"
              color="text-text-secondary"
              html={description ?? ''}
              variant="body-long-01"
            />
          </Box>
        ) : null}
      </Stack>
    );
  },
);

export default AboutComponent;
